module.exports = __webpack_public_path__ + "static/media/paper-money-two-white.58b7b524.svg";